import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"
}), 'NavigateNextOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigateNextOutlined.js
// module id = 4997
// module chunks = 2